import { render, staticRenderFns } from "./RiskConferenceWarning.vue?vue&type=template&id=04412f62&scoped=true&"
import script from "./RiskConferenceWarning.vue?vue&type=script&lang=js&"
export * from "./RiskConferenceWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04412f62",
  null
  
)

export default component.exports